
  export const style = {
    api: {
      apiProduction: "https://mestreconstrutor.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "mestreconstrutor",
      hostHeader: "mestreconstrutormc",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.amazonaws.com/Logos/logo1_mestreconstrutor.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.amazonaws.com/Logos/logotipo.png",
      browserLogo: "https://timcoo-geral.s3.amazonaws.com/Logos/favicon_mestreconstrutor.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.amazonaws.com/Logos/logo1_mestreconstrutor.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "Mestre Construtor MC",
      nameScore: "Pontos",
      nameStore: "Loja",
      nameAcademy: localStorage.getItem("nameAcademy") || "Capacitação",
      nameTeam: localStorage.getItem("nameTeam") || "Comunidade",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Caixa de ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#009AEA",
      secondaryColor: localStorage.getItem("secondaryColor") || "#007CB3",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: true,
      externalUse: false,
      customClient: true,
      customMenuItem: true,
      autoRegister: true,
      recaptchaVersion: "V1",
      showBirthday: "false"
    },
  };
